module.exports = __webpack_public_path__ + "img/upis.7acb3754.svg";